import { yup } from '@guiker/yup-util'

export const readCategoriesBySlugQueryParams = yup.object({
  _embed: yup.boolean().default(true),
  per_page: yup.string(),
})
